import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const isAuthRequest =
        error.config?.url?.includes('/login') ||
        error.config?.url?.includes('/register');
      if (!isAuthRequest) {
        localStorage.removeItem('auth_token');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export const contactService = {
  getContacts: async () => {
    const response = await api.get('/customer-contacts');
    return response.data;
  },
  getContact: async (id) => {
    const response = await api.get(`/customer-contacts/${id}`);
    return response.data;
  },
  createContact: async (data) => {
    const response = await api.post('/customer-contacts', data);
    return response.data;
  },
  updateContact: async (id, data) => {
    const response = await api.put(`/customer-contacts/${id}`, data);
    return response.data;
  },
  deleteContact: async (id) => {
    const response = await api.delete(`/customer-contacts/${id}`);
    return response.data;
  },
};
